// Enumerator of the different supported form fields
export enum FormElementEnum {
    Textbox = "textbox",
    Date = "date",
    TextArea = "textarea",
    TimeZone = "timezone",
    Time = "time",
}

// Details of a formElement to be passed into the product config
export type FormElement = {
    type: FormElementEnum;
    questionId: string;
    label: string;
    englishLabelText: string;
    maxCharLength?: number;    
    placeholder?: string;
    defaultDate?: Date;
};

// The dictionary mapping product names to form element configurations
export type ProductConfig = {
    [key: string]: FormElement[];
};

// FormQuestion this is the important info for each form element that must be serialized and returned.
export type FormQuestion = {
    questionId: string;
    prompt: string;
    response: string;
}

// FormQuestionDict is a dictionary mapping formquestions to ids for ease of update/access
export type FormQuestionDict = {
    [key: string]: FormQuestion;
};